const waistCircumferenceDescription =
  'A larger waist circumference can mean more "deep" (visceral) fat which is an unhealthy type of fat that wraps around internal organs and can lead to additional health risks. Generally a lower waist circumference is better. Waist circumference has been widely used in the past due to its simplicity.'

const vatMassDescription =
  'Visceral adipose tissue (VAT) mass is the fat stored deep inside the belly, wrapped around internal organs including the liver, stomach and intestines. VAT is metabolically active and produces hormones and inflammatory substances. High levels of VAT are associated with increased risk of metabolic diseases.'

const eatDescription =
  ': EAT is a particular form of visceral fat deposited around the heart and is found to be a metabolically active organ that generates various bioactive molecules, which may significantly affect cardiac function.'

const subcutaneousDescription =
  ': The fat that is generally stored just below the surface of the skin. Subcutaneous fat is not related to many of the classic obesity-related pathologies, such as heart disease, cancer, and stroke and is generally a protective fat.'

const ectopicDescription =
  ': The storage of triglycerides (fats) in tissues other than adipose tissue that are only supposed to contain small amounts of fat, such as the liver, skeletal muscle, heart, and pancreas. These fats can interfere with cellular function. The cause for accumulation of Ectopic fat is unknown.'

const leanMassGlossary =
  'Lean mass is the mass of muscle, skeletal tissue, and water. In a 2-component model, where water and skeletal tissue are both included in lean mass, the formula is:'

const whrGlossary =
  'The waist to hip (WHR) ratio is obtained from dividing the circumference of the waist (the narrowest point between the hips and ribs) by the circumference of the hips (the widest part of the hips).'

const sharedChrome = {
  es: {
    'Your VAT Mass:': 'Tu masa de grasa visceral:',
    'Your Metabolic Age:': 'Tu edad metabólica:',
    [waistCircumferenceDescription]:
      'Una circunferencia de cintura mayor puede indicar más grasa “profunda” (visceral), un tipo de grasa poco saludable que envuelve órganos internos y puede aumentar riesgos de salud. En general, una circunferencia menor es mejor. Se ha usado mucho por su sencillez.',
    [vatMassDescription]:
      'La masa de tejido adiposo visceral (VAT) es la grasa almacenada en profundidad en el abdomen, alrededor de órganos como el hígado, el estómago y los intestinos. El VAT es metabólicamente activo y produce hormonas y sustancias inflamatorias. Niveles altos se asocian a mayor riesgo de enfermedades metabólicas.',
    'Your measurement trends': 'Tus tendencias de medidas',
    'August Leaders -': 'Líderes de agosto -',
    'adipocytes (fat cells)': 'adipocitos (células grasas)',
    [eatDescription]:
      ': El EAT es una forma de grasa visceral depositada alrededor del corazón y es un órgano metabólicamente activo que genera moléculas bioactivas que pueden afectar la función cardíaca.',
    'Subcutaneous Fat': 'Grasa subcutánea',
    [subcutaneousDescription]:
      ': La grasa que suele almacenarse justo bajo la piel. No se relaciona con muchas patologías clásicas de la obesidad, como enfermedad cardíaca, cáncer e ictus, y en general es una grasa protectora.',
    'Ectopic Fat': 'Grasa ectópica',
    [ectopicDescription]:
      ': El almacenamiento de triglicéridos (grasas) en tejidos que no son adiposos y que solo deberían contener pequeñas cantidades de grasa, como hígado, músculo esquelético, corazón y páncreas. Estas grasas pueden interferir con la función celular. Se desconoce la causa de su acumulación.',
    [leanMassGlossary]:
      'La masa magra es la masa de músculo, tejido esquelético y agua. En un modelo de 2 componentes, donde el agua y el tejido esquelético se incluyen en la masa magra, la fórmula es:',
    [whrGlossary]:
      'El índice cintura-cadera (WHR) se obtiene dividiendo la circunferencia de la cintura (el punto más estrecho entre caderas y costillas) por la circunferencia de las caderas (la parte más ancha de las caderas).',
    'The partner site may not auto fill your information, but the data IS being passed along to the partner.':
      'Es posible que el sitio del partner no rellene automáticamente tus datos, pero los datos SÍ se envían al partner.',
    '| Waist:': '| Cintura:',
    'Click the "continue" button to shop at':
      'Haz clic en el botón "continuar" para comprar en',
    'click to close': 'clic para cerrar',
    'Measurement location guide': 'Guía de ubicación de las medidas',
    Information: 'Información',
    'Close Question Information': 'Cerrar información de la pregunta',
    'There are three possible outcomes after taking the survey—':
      'Hay tres resultados posibles después de hacer la encuesta:',
    'Waist Data': 'Datos de cintura',
  },
  de: {
    'Fitness Information': 'Fitnessinformationen',
    'Your VAT Mass:': 'Ihre viszerale Fettmasse:',
    'Your Metabolic Age:': 'Ihr metabolisches Alter:',
    [waistCircumferenceDescription]:
      'Ein größerer Taillenumfang kann auf mehr „tiefes“ (viszerales) Fett hinweisen, ein ungesundes Fett, das innere Organe umhüllt und zusätzliche Gesundheitsrisiken mit sich bringen kann. Im Allgemeinen ist ein geringerer Taillenumfang besser. Der Taillenumfang wurde früher wegen seiner Einfachheit häufig verwendet.',
    [vatMassDescription]:
      'Die Masse des viszeralen Fettgewebes (VAT) ist das Fett, das tief im Bauch um innere Organe wie Leber, Magen und Darm gespeichert wird. VAT ist stoffwechselaktiv und produziert Hormone und entzündliche Substanzen. Hohe Werte sind mit einem erhöhten Risiko für Stoffwechselerkrankungen verbunden.',
    'Click to Enlarge Chart': 'Klicken, um das Diagramm zu vergrößern',
    'Click to Close': 'Zum Schließen klicken',
    Measurement: 'Messung',
    'Bodyshape Rating': 'Körperformbewertung',
    'August Leaders -': 'August-Spitzenreiter -',
    'adipocytes (fat cells)': 'Adipozyten (Fettzellen)',
    [eatDescription]:
      ': EAT ist eine besondere Form viszeralen Fetts um das Herz und gilt als stoffwechselaktives Organ, das bioaktive Moleküle erzeugt, die die Herzfunktion erheblich beeinflussen können.',
    'Subcutaneous Fat': 'Unterhautfett',
    [subcutaneousDescription]:
      ': Das Fett, das in der Regel direkt unter der Haut gespeichert wird. Unterhautfett steht nicht mit vielen klassischen adipositasbedingten Erkrankungen wie Herzkrankheit, Krebs und Schlaganfall in Zusammenhang und ist in der Regel schützend.',
    'Ectopic Fat': 'Ektopes Fett',
    [ectopicDescription]:
      ': Die Speicherung von Triglyceriden (Fetten) in anderen Geweben als Fettgewebe, die nur geringe Fettmengen enthalten sollten, etwa Leber, Skelettmuskel, Herz und Bauchspeicheldrüse. Dieses Fett kann die Zellfunktion stören. Die Ursache der Ansammlung ist unbekannt.',
    [leanMassGlossary]:
      'Die Magermasse ist die Masse aus Muskel, Skelettgewebe und Wasser. In einem 2-Komponenten-Modell, in dem Wasser und Skelettgewebe zur Magermasse zählen, lautet die Formel:',
    [whrGlossary]:
      'Das Taille-Hüft-Verhältnis (WHR) ergibt sich, indem der Taillenumfang (engste Stelle zwischen Hüften und Rippen) durch den Hüftumfang (breiteste Stelle der Hüften) geteilt wird.',
    'Basal Metabolic Rate (BMR)': 'Grundumsatz (BMR)',
    'The partner site may not auto fill your information, but the data IS being passed along to the partner.':
      'Die Partnerseite füllt Ihre Daten möglicherweise nicht automatisch aus, aber die Daten WERDEN an den Partner übermittelt.',
    '| Waist:': '| Taille:',
    'Click the "continue" button to shop at':
      'Klicken Sie auf „Weiter“, um einzukaufen bei',
    'click to close': 'zum Schließen klicken',
    'Click to Show Instructions': 'Klicken, um Anweisungen anzuzeigen',
    'Measurement Comparisons': 'Messvergleiche',
    Difference: 'Differenz',
    'Measurement location guide': 'Anleitung zu den Messpositionen',
    Information: 'Informationen',
    'Close Question Information': 'Frageinformationen schließen',
    'There are three possible outcomes after taking the survey—':
      'Nach der Umfrage gibt es drei mögliche Ergebnisse:',
    'Please contact support for help or more information.':
      'Bitte wenden Sie sich für Hilfe oder weitere Informationen an den Support.',
  },
}

const localeWellness = {
  fr: {
    'Your VAT Mass:': 'Votre masse de graisse viscérale :',
    'Your Metabolic Age:': 'Votre âge métabolique :',
    [waistCircumferenceDescription]:
      'Un tour de taille plus élevé peut indiquer davantage de graisse « profonde » (viscérale), un type de graisse nocif qui entoure les organes internes et peut augmenter les risques pour la santé. En général, un tour de taille plus faible est préférable. Il a longtemps été utilisé pour sa simplicité.',
    [vatMassDescription]:
      'La masse de tissu adipeux viscéral (VAT) est la graisse stockée en profondeur dans l’abdomen, autour d’organes comme le foie, l’estomac et les intestins. Le VAT est métaboliquement actif et produit des hormones et des substances inflammatoires. Des niveaux élevés sont associés à un risque accru de maladies métaboliques.',
    'Measurement location guide': 'Guide des emplacements de mesure',
    'Subcutaneous Fat': 'Graisse sous-cutanée',
    'Ectopic Fat': 'Graisse ectopique',
    'adipocytes (fat cells)': 'adipocytes (cellules graisseuses)',
    [eatDescription]:
      ' : L’EAT est une forme de graisse viscérale autour du cœur, un organe métaboliquement actif qui génère des molécules bioactives pouvant affecter la fonction cardiaque.',
    [subcutaneousDescription]:
      ' : La graisse généralement stockée juste sous la peau. Elle n’est pas liée à beaucoup de pathologies classiques de l’obésité et est en général protectrice.',
    [ectopicDescription]:
      ' : Le stockage de triglycérides dans des tissus autres que le tissu adipeux, qui ne devraient contenir que de petites quantités de graisse, comme le foie, le muscle squelettique, le cœur et le pancréas.',
    [leanMassGlossary]:
      'La masse maigre est la masse de muscle, de tissu squelettique et d’eau. Dans un modèle à 2 composantes, où eau et tissu squelettique sont inclus, la formule est :',
    [whrGlossary]:
      'Le rapport taille-hanches (WHR) s’obtient en divisant le tour de taille (point le plus étroit entre hanches et côtes) par le tour de hanches (partie la plus large).',
    'essential body fat': 'graisse corporelle essentielle',
  },
  it: {
    'Your VAT Mass:': 'La tua massa di grasso viscerale:',
    'Your Metabolic Age:': 'La tua età metabolica:',
    [waistCircumferenceDescription]:
      'Una circonferenza vita maggiore può indicare più grasso “profondo” (viscerale), un tipo di grasso poco salutare che avvolge gli organi interni e può aumentare i rischi per la salute. In generale è meglio una circonferenza più bassa. È stata usata a lungo per la sua semplicità.',
    [vatMassDescription]:
      'La massa di tessuto adiposo viscerale (VAT) è il grasso depositato in profondità nell’addome, intorno a organi come fegato, stomaco e intestino. Il VAT è metabolicamente attivo e produce ormoni e sostanze infiammatorie. Livelli elevati sono associati a un maggior rischio di malattie metaboliche.',
    'Subcutaneous Fat': 'Grasso sottocutaneo',
    'Ectopic Fat': 'Grasso ectopico',
    [eatDescription]:
      ': L’EAT è una forma di grasso viscerale depositata intorno al cuore ed è un organo metabolicamente attivo che genera molecole bioattive che possono influenzare la funzione cardiaca.',
    [subcutaneousDescription]:
      ': Il grasso generalmente depositato appena sotto la pelle. Il grasso sottocutaneo non è legato a molte patologie classiche dell’obesità, come malattie cardiache, cancro e ictus, ed è in genere un grasso protettivo.',
    [ectopicDescription]:
      ': L’accumulo di trigliceridi (grassi) in tessuti diversi dal tessuto adiposo, che dovrebbero contenerne solo piccole quantità, come fegato, muscolo scheletrico, cuore e pancreas. Questi grassi possono interferire con la funzione cellulare. La causa dell’accumulo è sconosciuta.',
    [leanMassGlossary]:
      'La massa magra è la massa di muscolo, tessuto scheletrico e acqua. In un modello a 2 componenti, in cui acqua e tessuto scheletrico sono inclusi nella massa magra, la formula è:',
    [whrGlossary]:
      'Il rapporto vita-fianchi (WHR) si ottiene dividendo la circonferenza della vita (il punto più stretto tra fianchi e costole) per la circonferenza dei fianchi (la parte più larga dei fianchi).',
    'adipocytes (fat cells)': 'adipociti (cellule adipose)',
  },
  pt: {
    'Your VAT Mass:': 'Sua massa de gordura visceral:',
    'Your Metabolic Age:': 'Sua idade metabólica:',
    [waistCircumferenceDescription]:
      'Uma circunferência da cintura maior pode indicar mais gordura “profunda” (visceral), um tipo pouco saudável que envolve órgãos internos e pode aumentar riscos à saúde. Em geral, uma circunferência menor é melhor. Foi muito usada pela simplicidade.',
    [vatMassDescription]:
      'A massa de tecido adiposo visceral (VAT) é a gordura armazenada no fundo do abdômen, em volta de órgãos como fígado, estômago e intestinos. O VAT é metabolicamente ativo e produz hormônios e substâncias inflamatórias. Níveis altos associam-se a maior risco de doenças metabólicas.',
    'Subcutaneous Fat': 'Gordura subcutânea',
    'Ectopic Fat': 'Gordura ectópica',
  },
  zh_CN: {
    'Your VAT Mass:': '您的内脏脂肪质量：',
    'Your Metabolic Age:': '您的代谢年龄：',
    [waistCircumferenceDescription]:
      '腰围较大可能意味着更多“深层”（内脏）脂肪，这是包裹内脏、可能增加健康风险的不健康脂肪。一般来说腰围越小越好。腰围因测量简单而被广泛使用。',
    [vatMassDescription]:
      '内脏脂肪组织（VAT）质量是储存在腹部深处、包裹肝、胃和肠道等内脏的脂肪。VAT 具有代谢活性，会产生激素和炎症物质。高水平与代谢疾病风险增加有关。',
    'Subcutaneous Fat': '皮下脂肪',
    'Ectopic Fat': '异位脂肪',
  },
  zh_TW: {
    'Your VAT Mass:': '您的內臟脂肪質量：',
    'Your Metabolic Age:': '您的代謝年齡：',
    [waistCircumferenceDescription]:
      '腰圍較大可能代表較多「深層」（內臟）脂肪，這是包覆內臟、可能增加健康風險的不健康脂肪。一般而言腰圍越小越好。腰圍因測量簡單而被廣泛使用。',
    [vatMassDescription]:
      '內臟脂肪組織（VAT）質量是儲存在腹部深處、包覆肝、胃與腸道等內臟的脂肪。VAT 具代謝活性，會產生荷爾蒙與發炎物質。高量與代謝疾病風險增加有關。',
    'Subcutaneous Fat': '皮下脂肪',
    'Ectopic Fat': '異位脂肪',
  },
  ko: {
    'Your VAT Mass:': '내장 지방량:',
    'Your Metabolic Age:': '대사 나이:',
    [waistCircumferenceDescription]:
      '허리둘레가 클수록 “깊은”(내장) 지방이 더 많을 수 있습니다. 이는 내장을 감싸 건강 위험을 높일 수 있는 해로운 지방입니다. 일반적으로 허리둘레가 작을수록 좋습니다. 측정이 간단해 널리 쓰여 왔습니다.',
    [vatMassDescription]:
      '내장 지방 조직(VAT) 질량은 배 안쪽에 저장되어 간, 위, 장 등 내장을 감싸는 지방입니다. VAT는 대사적으로 활성이며 호르몬과 염증 물질을 만듭니다. 수치가 높으면 대사 질환 위험이 커집니다.',
    'Subcutaneous Fat': '피하지방',
    'Ectopic Fat': '이소성 지방',
  },
  nl: {
    'Your VAT Mass:': 'Uw viscerale vetmassa:',
    'Your Metabolic Age:': 'Uw metabole leeftijd:',
    [waistCircumferenceDescription]:
      'Een grotere tailleomtrek kan wijzen op meer “diep” (visceraal) vet, een ongezond vet dat organen omhult en extra gezondheidsrisico’s kan geven. Over het algemeen is een kleinere omtrek beter. Tailleomtrek werd vroeger vaak gebruikt vanwege de eenvoud.',
    [vatMassDescription]:
      'De massa van visceraal vetweefsel (VAT) is vet dat diep in de buik rond organen zoals lever, maag en darmen is opgeslagen. VAT is metabolisch actief en produceert hormonen en ontstekingsstoffen. Hoge waarden hangen samen met een hoger risico op stofwisselingsziekten.',
    'Subcutaneous Fat': 'Onderhuids vet',
    'Ectopic Fat': 'Ectopisch vet',
  },
  fi: {
    'Your VAT Mass:': 'Viskeraalinen rasvamassasi:',
    'Your Metabolic Age:': 'Aineenvaihdunnallinen ikäsi:',
    [waistCircumferenceDescription]:
      'Suurempi vyötärönympärys voi tarkoittaa enemmän ”syvää” (viskeraalista) rasvaa, joka ympäröi sisäelimiä ja voi lisätä terveysriskejä. Yleensä pienempi ympärys on parempi. Vyötärönympärystä on käytetty paljon sen yksinkertaisuuden vuoksi.',
    [vatMassDescription]:
      'Viskeraalisen rasvakudoksen (VAT) massa on rasvaa, joka on varastoitunut vatsan sisälle maksan, mahan ja suoliston ympärille. VAT on metabolisesti aktiivista ja tuottaa hormoneja ja tulehdusta aiheuttavia aineita. Korkeat tasot liittyvät metabolisten sairauksien riskiin.',
    'Subcutaneous Fat': 'Ihonalainen rasva',
    'Ectopic Fat': 'Ektopinen rasva',
  },
  ru: {
    'Your VAT Mass:': 'Ваша масса висцерального жира:',
    'Your Metabolic Age:': 'Ваш метаболический возраст:',
    [waistCircumferenceDescription]:
      'Большая окружность талии может означать больше «глубокого» (висцерального) жира — нездорового жира вокруг внутренних органов, повышающего риски для здоровья. Как правило, меньшая окружность лучше. Этот показатель широко использовали из‑за простоты измерения.',
    [vatMassDescription]:
      'Масса висцеральной жировой ткани (VAT) — жир в глубине живота вокруг органов, включая печень, желудок и кишечник. VAT метаболически активна и вырабатывает гормоны и воспалительные вещества. Высокий уровень связан с риском метаболических заболеваний.',
    'Subcutaneous Fat': 'Подкожный жир',
    'Ectopic Fat': 'Эктопический жир',
  },
  sv: {
    'Your VAT Mass:': 'Din viscerala fettmassa:',
    'Your Metabolic Age:': 'Din metaboliska ålder:',
    [waistCircumferenceDescription]:
      'Ett större midjemått kan betyda mer ”djupt” (visceralt) fett, ett ohälsosamt fett som omsluter inre organ och kan öka hälsorisker. Generellt är ett mindre mått bättre. Midjemått har använts mycket på grund av sin enkelhet.',
    [vatMassDescription]:
      'Massan av visceralt fettvävnad (VAT) är fettet som lagras djupt i magen runt organ som lever, mage och tarmar. VAT är metabolt aktivt och producerar hormoner och inflammatoriska ämnen. Höga nivåer kopplas till ökad risk för metabola sjukdomar.',
    'Subcutaneous Fat': 'Subkutant fett',
    'Ectopic Fat': 'Ektopiskt fett',
  },
  ja: {
    'Your VAT Mass:': '内臓脂肪量：',
    'Your Metabolic Age:': '代謝年齢：',
    [waistCircumferenceDescription]:
      '腹囲が大きいと、内臓を包む「深い」（内臓）脂肪が多い可能性があります。これは健康リスクを高めうる脂肪です。一般に腹囲は小さい方が望ましいです。測定が簡単なため広く使われてきました。',
    [vatMassDescription]:
      '内臓脂肪組織（VAT）量は、腹部の奥に蓄積し、肝臓・胃・腸などの臓器を包む脂肪です。VAT は代謝的に活性で、ホルモンや炎症物質を産生します。量が多いと代謝疾患のリスクが高まります。',
    'Subcutaneous Fat': '皮下脂肪',
    'Ectopic Fat': '異所性脂肪',
  },
  tr: {
    'Your VAT Mass:': 'Viseral yağ kütleniz:',
    'Your Metabolic Age:': 'Metabolik yaşınız:',
    [waistCircumferenceDescription]:
      'Daha büyük bel çevresi, iç organları saran ve sağlık risklerini artırabilen daha fazla “derin” (viseral) yağ anlamına gelebilir. Genel olarak daha düşük bel çevresi daha iyidir. Ölçümü kolay olduğu için yaygın kullanılmıştır.',
    [vatMassDescription]:
      'Viseral yağ dokusu (VAT) kütlesi, karın içinde karaciğer, mide ve bağırsaklar gibi organların çevresinde depolanan yağdır. VAT metabolik olarak aktiftir ve hormon ile inflamatuar maddeler üretir. Yüksek düzeyler metabolik hastalık riskiyle ilişkilidir.',
    'Subcutaneous Fat': 'Cilt altı yağ',
    'Ectopic Fat': 'Ektopik yağ',
  },
  cs: {
    'Your VAT Mass:': 'Vaše hmotnost viscerálního tuku:',
    'Your Metabolic Age:': 'Váš metabolický věk:',
    [waistCircumferenceDescription]:
      'Větší obvod pasu může znamenat více „hlubokého“ (viscerálního) tuku, nezdravého tuku kolem vnitřních orgánů, který může zvyšovat zdravotní rizika. Obecně je nižší obvod lepší. Obvod pasu se hojně používal pro svou jednoduchost.',
    [vatMassDescription]:
      'Hmotnost viscerální tukové tkáně (VAT) je tuk uložený hluboko v břiše kolem orgánů včetně jater, žaludku a střev. VAT je metabolicky aktivní a produkuje hormony a zánětlivé látky. Vysoké hodnoty souvisejí s vyšším rizikem metabolických onemocnění.',
    'Subcutaneous Fat': 'Podkožní tuk',
    'Ectopic Fat': 'Ektopický tuk',
  },
  el: {
    'Your VAT Mass:': 'Η μάζα σπλαχνικού λίπους σας:',
    'Your Metabolic Age:': 'Η μεταβολική ηλικία σας:',
    [waistCircumferenceDescription]:
      'Μεγαλύτερη περίμετρος μέσης μπορεί να σημαίνει περισσότερο «βαθύ» (σπλαχνικό) λίπος, έναν ανθυγιεινό τύπο λίπους που τυλίγει εσωτερικά όργανα και μπορεί να αυξήσει κινδύνους υγείας. Γενικά μικρότερη περίμετρος είναι καλύτερη. Χρησιμοποιήθηκε ευρέως λόγω απλότητας.',
    [vatMassDescription]:
      'Η μάζα σπλαχνικού λιπώδους ιστού (VAT) είναι το λίπος που αποθηκεύεται βαθιά στην κοιλιά γύρω από όργανα όπως το ήπαρ, το στομάχι και τα έντερα. Το VAT είναι μεταβολικά ενεργό και παράγει ορμόνες και φλεγμονώδεις ουσίες. Υψηλά επίπεδα σχετίζονται με αυξημένο κίνδυνο μεταβολικών νοσημάτων.',
    'Subcutaneous Fat': 'Υποδόριο λίπος',
    'Ectopic Fat': 'Έκτοπο λίπος',
  },
  hr: {
    'Your VAT Mass:': 'Vaša masa visceralnog masnog tkiva:',
    'Your Metabolic Age:': 'Vaša metabolička dob:',
    [waistCircumferenceDescription]:
      'Veći opseg struka može značiti više „duboke“ (visceralne) masti, nezdrave masti oko unutarnjih organa koja može povećati zdravstvene rizike. Općenito je manji opseg bolji. Opseg struka se često koristio zbog jednostavnosti.',
    [vatMassDescription]:
      'Masa visceralnog masnog tkiva (VAT) masnoća je pohranjena duboko u trbuhu oko organa uključujući jetru, želudac i crijeva. VAT je metabolički aktivan i proizvodi hormone i upalne tvari. Visoke razine povezane su s većim rizikom metaboličkih bolesti.',
    'Subcutaneous Fat': 'Potkožna mast',
    'Ectopic Fat': 'Ektopska mast',
  },
}

export default {
  ...sharedChrome,
  ...Object.fromEntries(
    Object.entries(localeWellness).map(([code, phrases]) => [
      code,
      { ...(sharedChrome[code] || {}), ...phrases },
    ])
  ),
}
